import * as Yup from 'yup';
import { LegalProceedingProcessData } from '../../../../../../shared/types/legalProceedings/legalProceedings';

export const initialValues: LegalProceedingProcessData = {
    dateReceipt: '',
    registeredCompany: '',
    documentClaimant: '',
    nameClaimant: '',
    documentProcessed: '',
    nameProcessed: '',
    insuredDocument: '',
    insuredName: '',
    requirementNumber: '',
    fileNumber: '',
    namePersonSubscribe: '',
    policy: '',
    senderEmail: '',
    plate: '',
    expirationDate: '',
    legalProceedings: '',
    pqrIdentified: '',
    submittingEntity: '',
    address: '',
    status: '',
    subject: '',
    location: '',
    detail: '',
};

export const validationSchema = Yup.object({
    dateReceipt: Yup.string().required('La fecha de recepción es obligatoria'),
    registeredCompany: Yup.string().required(
        'El radicado de la compañia es obligatorio'
    ),
    documentClaimant: Yup.string().required(
        'El documento del accionante obligatorio'
    ),
    nameClaimant: Yup.string().required(
        'El nombre del accionante es obligatorio'
    ),
    requirementNumber: Yup.string().required(
        'El número del requerimiento es obligatorio'
    ),
    fileNumber: Yup.string().required(
        'El número del expediente es obligatorio'
    ),
    namePersonSubscribe: Yup.string().required(
        'El nombre de la persona que subscribe es obligatorio'
    ),
    policy: Yup.string().required('La póliza es obligatoria'),
    senderEmail: Yup.string()
        .email('El correo es inválido')
        .required('El correo es obligatorio')
        .test('Validate Email', 'El correo es inválido', (value) => {
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());
        }),
    legalProceedings: Yup.string().required(
        'El proceso judicial es obligatorio'
    ),
    submittingEntity: Yup.string().required(
        'La entidad remitente es obligatoria'
    ),
    status: Yup.string().required('El estado es obligatorio'),
    subject: Yup.string().required('El asunto es obligatorio'),
    location: Yup.string().required('La ubicación es obligatoria'),
});
